import { FlowStepRunner } from "../FlowStepRunner";
import { FlowExecutionData } from "../../Engine/FlowExecutionData";
import { RunTreeRule } from "./RunTreeRule";
import { IUserInfo } from "../../../Plugins/DataStorage/IUserInfo";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { FlowStepTestContext } from "../../Structure/FlowTestingContext";
import { FlowEngine } from "../../Engine/FlowEngine";

export class RunTreeRuleRunner extends FlowStepRunner<RunTreeRule> {
    async start(
        _user: IUserInfo,
        _thread: string,
        _executionData: ExecutionData,
        _flowExecutionData: FlowExecutionData,
        testContext?: FlowStepTestContext
    ): Promise<void> {
        await FlowEngine.stepComplete(_user, _flowExecutionData, _thread, this.stepData!, undefined, testContext);
    }
}
